import SystemUpdateIcon from "@mui/icons-material/SystemUpdate";
import {
  Box,
  IconButton,
  Menu,
  MenuItem,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import packageData from "../../../package.json";

export function VersionIndicator(props: { experimentVersion?: string }) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box
      sx={{
        position: "fixed",
        bottom: { xs: 75, md: 16 }, // Matches your 810px logic via MUI breakpoints
        right: 16,
        zIndex: 1200, // Ensure it sits above other sidebar elements
      }}
    >
      <Tooltip title="System Versions">
        <IconButton
          onClick={handleClick}
          size="small"
          sx={{
            bgcolor: "background.paper",
            boxShadow: 2,
            "&:hover": { bgcolor: "action.hover" },
            border: "1px solid",
            borderColor: "divider",
          }}
        >
          <SystemUpdateIcon fontSize="small" color="primary" />
        </IconButton>
      </Tooltip>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        transformOrigin={{ horizontal: "right", vertical: "bottom" }}
        anchorOrigin={{ horizontal: "right", vertical: "top" }}
        PaperProps={{
          sx: {
            mt: -1, // Pop slightly above the button
            borderRadius: 2,
            minWidth: 180,
            boxShadow: "0px 4px 20px rgba(0,0,0,0.1)",
          },
        }}
      >
        <MenuItem disabled sx={{ opacity: "1 !important", py: 1 }}>
          <Box>
            <Typography
              variant="caption"
              display="block"
              color="text.secondary"
              fontWeight="700"
            >
              EXPERIMENT
            </Typography>
            <Typography variant="body2">
              v{props.experimentVersion ?? "1.0.0"}
            </Typography>
          </Box>
        </MenuItem>

        <MenuItem disabled sx={{ opacity: "1 !important", py: 1 }}>
          <Box>
            <Typography
              variant="caption"
              display="block"
              color="text.secondary"
              fontWeight="700"
            >
              SME FRAMEWORK
            </Typography>
            <Typography variant="body2">v{packageData.version}</Typography>
          </Box>
        </MenuItem>
      </Menu>
    </Box>
  );
}
